export var ThemeVariables = {
    fandomGlobalNavBackgroundColor: '--fandom-global-nav-background-color',
    fandomGlobalNavTextColor: '--fandom-global-nav-text-color',
    fandomGlobalNavLinkColor: '--fandom-global-nav-link-color',
    fandomGlobalNavLinkColorhover: '--fandom-global-nav-link-color--hover',
    fandomGlobalNavIconColor: '--fandom-global-nav-icon-color',
    fandomGlobalNavIconBackgroundColor: '--fandom-global-nav-icon-background-color',
    fandomGlobalNavIconBackgroundColorhover: '--fandom-global-nav-icon-background-color--hover',
    fandomGlobalNavIconBackgroundColoractive: '--fandom-global-nav-icon-background-color--active',
    fandomGlobalNavIconBorderColor: '--fandom-global-nav-icon-border-color',
    fandomGlobalNavIconBorderColorhover: '--fandom-global-nav-icon-border-color--hover',
    fandomGlobalNavIconBorderColoractive: '--fandom-global-nav-icon-border-color--active',
    fandomGlobalNavBottomIconColor: '--fandom-global-nav-bottom-icon-color',
    fandomGlobalNavCounterBackgroundColor: '--fandom-global-nav-counter-background-color',
    fandomGlobalNavCounterLabelColor: '--fandom-global-nav-counter-label-color',
    fandomGlobalNavMobileLogo: '--fandom-global-nav-mobile-logo',
    fandomGlobalNavSearchActiveLinkBackgroundColor: '--fandom-global-nav-search-active-link-background-color',
    fandomGlobalNavSearchActiveLinkBorderColor: '--fandom-global-nav-search-active-link-border-color',
    fandomGlobalNavLogoSeparatorColor: '--fandom-global-nav-logo-separator-color',
    fandomGlobalNavSearchSeparatorColor: '--fandom-global-nav-search-separator-color',
    fandomGlobalNavBottomShadow: '--fandom-global-nav-bottom-shadow',
    fandomGlobalNavGpLegacyLogo: '--fandom-global-nav-gp-legacy-logo',
    fandomGlobalNavBorderTopWidth: '--fandom-global-nav-border-top-width',
    fandomTextColor: '--fandom-text-color',
    fandomTextColorrgb: '--fandom-text-color--rgb',
    fandomTextColorhover: '--fandom-text-color--hover',
    fandomLinkColor: '--fandom-link-color',
    fandomLinkColorhover: '--fandom-link-color--hover',
    fandomLinkColorrgb: '--fandom-link-color--rgb',
    fandomLinkColorfadeout: '--fandom-link-color--fadeout',
    fandomAccentColor: '--fandom-accent-color',
    fandomAccentColorhover: '--fandom-accent-color--hover',
    fandomAccentLabelColor: '--fandom-accent-label-color',
    fandomBorderColor: '--fandom-border-color',
    fandomSecondaryButtonColor: '--fandom-secondary-button-color',
    fandomSecondaryButtonColorhover: '--fandom-secondary-button-color--hover',
    fandomDropdownBackgroundColor: '--fandom-dropdown-background-color',
    fandomNotificationsBackgroundColor: '--fandom-notifications-background-color',
    fandomNotificationsReadCardBackgroundColor: '--fandom-notifications-read-card-background-color',
    fandomNotificationsUnreadCardBackgroundColor: '--fandom-notifications-unread-card-background-color',
    fandomNotificationsFooterTextColor: '--fandom-notifications-footer-text-color',
    fandomBannerNotificationBackgroundColor: '--fandom-banner-notification-background-color',
    fandomBannerNotificationsCloseIcon: '--fandom-banner-notifications-close-icon',
    themeBodyDynamicColor1: '--theme-body-dynamic-color-1',
    themeBodyDynamicColor1rgb: '--theme-body-dynamic-color-1--rgb',
    themeBodyDynamicColor2: '--theme-body-dynamic-color-2',
    themeBodyDynamicColor2rgb: '--theme-body-dynamic-color-2--rgb',
    themePageDynamicColor1: '--theme-page-dynamic-color-1',
    themePageDynamicColor1rgb: '--theme-page-dynamic-color-1--rgb',
    themePageDynamicColor1inverted: '--theme-page-dynamic-color-1--inverted',
    themePageDynamicColor1invertedrgb: '--theme-page-dynamic-color-1--inverted--rgb',
    themePageDynamicColor2: '--theme-page-dynamic-color-2',
    themePageDynamicColor2rgb: '--theme-page-dynamic-color-2--rgb',
    themeStickyNavDynamicColor1: '--theme-sticky-nav-dynamic-color-1',
    themeStickyNavDynamicColor1rgb: '--theme-sticky-nav-dynamic-color-1--rgb',
    themeStickyNavDynamicColor2: '--theme-sticky-nav-dynamic-color-2',
    themeStickyNavDynamicColor2rgb: '--theme-sticky-nav-dynamic-color-2--rgb',
    themeLinkDynamicColor1: '--theme-link-dynamic-color-1',
    themeLinkDynamicColor1rgb: '--theme-link-dynamic-color-1--rgb',
    themeLinkDynamicColor2: '--theme-link-dynamic-color-2',
    themeLinkDynamicColor2rgb: '--theme-link-dynamic-color-2--rgb',
    themeAccentDynamicColor1: '--theme-accent-dynamic-color-1',
    themeAccentDynamicColor1rgb: '--theme-accent-dynamic-color-1--rgb',
    themeAccentDynamicColor2: '--theme-accent-dynamic-color-2',
    themeAccentDynamicColor2rgb: '--theme-accent-dynamic-color-2--rgb',
    themeBodyBackgroundColor: '--theme-body-background-color',
    themeBodyBackgroundColorrgb: '--theme-body-background-color--rgb',
    themeBodyBackgroundImage: '--theme-body-background-image',
    themeBodyTextColor: '--theme-body-text-color',
    themeBodyTextColorhover: '--theme-body-text-color--hover',
    themeStickyNavBackgroundColor: '--theme-sticky-nav-background-color',
    themeStickyNavTextColor: '--theme-sticky-nav-text-color',
    themeStickyNavTextColorhover: '--theme-sticky-nav-text-color--hover',
    themePageBackgroundColor: '--theme-page-background-color',
    themePageBackgroundColorrgb: '--theme-page-background-color--rgb',
    themePageBackgroundColorsecondary: '--theme-page-background-color--secondary',
    themePageTextColor: '--theme-page-text-color',
    themePageTextColorrgb: '--theme-page-text-color--rgb',
    themePageTextColorhover: '--theme-page-text-color--hover',
    themePageTextMixColor: '--theme-page-text-mix-color',
    themePageTextMixColor95: '--theme-page-text-mix-color-95',
    themePageAccentMixColor: '--theme-page-accent-mix-color',
    themePageHeadingsFont: '--theme-page-headings-font',
    themeLinkColor: '--theme-link-color',
    themeLinkColorrgb: '--theme-link-color--rgb',
    themeLinkColorhover: '--theme-link-color--hover',
    themeLinkLabelColor: '--theme-link-label-color',
    themeAccentColor: '--theme-accent-color',
    themeAccentColorrgb: '--theme-accent-color--rgb',
    themeAccentColorhover: '--theme-accent-color--hover',
    themeAccentLabelColor: '--theme-accent-label-color',
    themeBorderColor: '--theme-border-color',
    themeBorderColorrgb: '--theme-border-color--rgb',
    themeAlertColor: '--theme-alert-color',
    themeAlertColorrgb: '--theme-alert-color--rgb',
    themeAlertColorhover: '--theme-alert-color--hover',
    themeAlertLabel: '--theme-alert-label',
    themeWarningColor: '--theme-warning-color',
    themeWarningColorrgb: '--theme-warning-color--rgb',
    themeWarningLabel: '--theme-warning-label',
    themeSuccessColor: '--theme-success-color',
    themeSuccessColorrgb: '--theme-success-color--rgb',
    themeSuccessLabel: '--theme-success-label',
    themeMessageLabel: '--theme-message-label',
    themeCommunityHeaderColor: '--theme-community-header-color',
    themeCommunityHeaderColorhover: '--theme-community-header-color--hover',
    themeBackgroundImageOpacity: '--theme-background-image-opacity',
    mwContentTextSidePadding: '--mw-content-text-side-padding',
    themeMessageColor: '--theme-message-color',
    themeTableBackgroundColor: '--theme-table-background-color',
    themeTableHeaderColor: '--theme-table-header-color',
    fandommobileTocCloseIconColor: '--fandommobile-toc-close-icon-color',
    fandommobileSectionEditIconColor: '--fandommobile-section-edit-icon-color',
    fandommobileBoxShadow: '--fandommobile-box-shadow',
    fandommobileBodyGradient: '--fandommobile-body-gradient',
};
